import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { Location } from '@angular/common';

@Component({
  selector: 'app-server-error',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="min-h-screen bg-gradient-to-br from-red-50 to-orange-50 flex items-center justify-center px-4">
      <div class="max-w-2xl w-full">
        <div class="bg-white rounded-3xl shadow-2xl p-12 text-center border border-red-100">
          <!-- Animated 500 -->
          <div class="mb-8">
            <div class="relative inline-block">
              <h1 class="text-9xl font-black text-transparent bg-clip-text bg-gradient-to-r from-red-600 to-orange-600">
                500
              </h1>
              <div class="absolute inset-0 blur-2xl opacity-30 bg-gradient-to-r from-red-400 to-orange-500"></div>
            </div>
          </div>

          <!-- Icon -->
          <div class="w-24 h-24 mx-auto mb-6 bg-gradient-to-br from-red-50 to-orange-100 rounded-2xl flex items-center justify-center">
            <svg class="w-12 h-12 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"></path>
            </svg>
          </div>

          <!-- Message -->
          <h2 class="text-3xl font-bold text-gray-900 mb-4">Server Error</h2>
          <p class="text-lg text-gray-600 mb-8 leading-relaxed">
            Oops! Something went wrong on our end. Our team has been notified and we're working to fix the issue.
          </p>

          <!-- Actions -->
          <div class="flex flex-col sm:flex-row gap-4 justify-center">
            <button
              (click)="reload()"
              class="inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-gray-100 text-gray-700 rounded-xl hover:bg-gray-200 transform hover:scale-105 transition-all duration-200 font-semibold">
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"></path>
              </svg>
              Try Again
            </button>
            <button
              (click)="goHome()"
              class="inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-gradient-to-r from-red-600 to-orange-600 text-white rounded-xl hover:shadow-lg transform hover:scale-105 transition-all duration-200 font-semibold">
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"></path>
              </svg>
              Back to Home
            </button>
          </div>

          <!-- Support Info -->
          <div class="mt-10 pt-8 border-t border-gray-200">
            <p class="text-sm text-gray-600 mb-3">If the problem persists, please contact our support team:</p>
            <a href="/contact" class="inline-flex items-center gap-2 text-red-600 hover:text-red-700 font-semibold">
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
              </svg>
              Contact Support
            </a>
          </div>
        </div>
      </div>
    </div>
  `,
  styles: []
})
export class ServerErrorComponent {
  constructor(private router: Router) {}

  reload(): void {
    window.location.reload();
  }

  goHome(): void {
    this.router.navigate(['/']);
  }
}
